import { render, staticRenderFns } from "./ADBatchEditModal.vue?vue&type=template&id=31a20466&scoped=true&"
import script from "./ADBatchEditModal.vue?vue&type=script&lang=js&"
export * from "./ADBatchEditModal.vue?vue&type=script&lang=js&"
import style0 from "./ADBatchEditModal.vue?vue&type=style&index=0&id=31a20466&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a20466",
  null
  
)

export default component.exports